import { loc } from '../common';

export default loc(
  7, 'CharredRuins4', ['Ashlands'],
  { type: 'misc',
    biomeArea: 2, quantity: 100,
    terrainDelta: [0, 6], minAlt: -10, radius: [12, 12],
    items: [],
  },
  'CharredRuins_small',
);
